<div class="flex flex-col space-y-4">
  <div class="flex justify-between items-center">
    <div class="flex flex-col items-start">
      <h1 class="font-semibold text-2xl">Profile graphs</h1>
      <span class="text-text-secondary/80">{{ selectedPeriodSubtitle() }}</span>
    </div>
    @if (data()) {
      <p-select
        class="border-border hover:border-primary focus:border-primary w-40"
        optionLabel="label"
        optionValue="value"
        [ngModel]="selectedPeriod()"
        [options]="periods"
        (ngModelChange)="onPeriodSelect($event)" />
    }
  </div>

  @switch (dataState().status) {
    @case ('loading') {
      <app-loading-skeleton variant="chart" />
      <app-loading-skeleton variant="chart" />
      <app-loading-skeleton variant="chart" />
    }
    @case ('error') {
      <app-error-state title="Failed to load graphs" [message]="error()!" (retry)="onRetry()" />
    }
    @case ('success') {
      @if (!hasSelectedPeriodData()) {
        <app-empty-state
          title="No data available"
          [message]="'No data available for selected period: ' + selectedPeriodLabel() + '.'" />
      } @else {
        <div animate.enter="content-enter" class="flex flex-col space-y-4 p-6 rounded-lg border border-border">
          @if (loadSeries().length > 0) {
            <app-area-chart
              theme="blue"
              title="Load profile [%]"
              yUnit="kW"
              [data]="loadSeries()"
              [groupId]="GROUP_ID"
              (chartInit)="onChartReady($event)" />
          }
          @if (socSeries().length > 0) {
            <app-area-chart
              theme="blue"
              title="SOC profile [%]"
              tooltipLabel="State of charge"
              yUnit="%"
              [data]="socSeries()"
              [groupId]="GROUP_ID"
              (chartInit)="onChartReady($event)" />
          }
          @if (powerInputSeries().length > 0) {
            <app-area-chart
              theme="blue"
              title="Power input profile [kW]"
              tooltipLabel="Power input"
              yUnit="kW"
              [data]="powerInputSeries()"
              [groupId]="GROUP_ID"
              (chartInit)="onChartReady($event)" />
          }
        </div>
      }
    }
  }
</div>
